<template>
    <div :class="{ 'detail-step__active': step.isActive }" class="detail-step">
        <div class="detail-step__name mb-2">
            <span>{{ step.name }}</span>
        </div>
        <ul class="list-unstyled">
            <li v-for="(link, index) in step.links" :key="index">
                <a target="_blank" :href="link.url"
                    ><i class="far fa-file-pdf"></i> {{ link.name }}</a
                >
            </li>
            <li v-if="step.publication">
                <span class="font-weight-bold">Publication:</span>
                {{ step.publication }}
            </li>
            <li v-if="step.deadline">
                <span class="font-weight-bold">Deadline:</span>
                {{ step.deadline }}
            </li>
            <li v-if="step.expected">
                <span class="font-weight-bold">Expected:</span>
                {{ step.expected }}
            </li>
            <li v-if="step.consultation">
                <span class="font-weight-bold">Consultation:</span>
                {{ step.consultation }}
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        step: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {};
    }
};
</script>

<style lang="scss">
.detail-step ul {
    font-size: 0.825rem;
    position: relative;
}

.detail-step ul li {
    line-height: 1.4;
    margin-bottom: 5px;
}

.detail-step ul span {
    display: block;
}

.detail-step ul a {
    color: $brand-black;
    display: block;
    font-weight: 600;
    text-decoration: underline;
    text-decoration-color: $green;

    svg {
        display: none;
    }
}

.detail-step ul li:first-child a {
    color: $green;
    text-decoration: none;

    & svg {
        display: inline-block;
    }
}

.detail-step__name {
    position: relative;
}

.detail-step__active ~ .detail-step .detail-step__name {
    &:after {
        content: '';
        position: absolute;
        top: -5px;
        height: calc(100% + 10px);
        width: calc(100% + 4px);
        background-color: $brand-white;
        opacity: 0.7;
        z-index: 100;
        left: -2px;
        border-radius: 90px;
    }
}

.detail-step__active ~ .detail-step ul {
    &:after {
        content: '';
        position: absolute;
        top: 0;
        height: 100%;
        width: 100%;
        background-color: $brand-white;
        opacity: 0.7;
        z-index: 100;
    }
}
</style>
